import React, { useState } from "react";
import {Button, Card, Checkbox, Popconfirm, Space, Tooltip, Typography} from "antd";
import {useTranslate} from "../../../../../hooks/translate.hook";
import { AddressListModal } from "./address-list.modal";
import { CustomCard } from "../../../../common/custom-card/custom.card";
import {BranchAddress, BranchAddressRequestValues} from "../../../../../models/branches/branch-data";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface AddressListCardProps {
    address: BranchAddress;
    edit?: (values: BranchAddressRequestValues, item?: BranchAddress) => Promise<any>;
    remove?: (item: BranchAddress) => Promise<any>;
    isDefault?: boolean;
    setDefault?: (item: BranchAddress) => Promise<any>;
}

export const AddressListCard: React.FC<AddressListCardProps> = ({address, edit, remove, isDefault, setDefault}) => {

    const t = useTranslate();
    const [isModalShown, setIsModalShown] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false);

    const cardRows = [
        {key: "name"},
        {key: "regName", label: "REG_NAME"},
        {key: "regNumber", label: "REG_NUMBER"},
        {key: "customsCode", label: "EORI"},
        {key: "country.name", label: "COUNTRY"},
        {key: "city"},
        {key: "street"},
        {key: "zip"},
        {key: "email", label: "EMAIL"},
        {key: "phone", label: "PHONE"},
    ];

    return (
        <>
            <Card
                className={"card"}
                title={
                    <Typography.Title level={5}>
                        {address.name}
                    </Typography.Title>
                }
                extra={edit || remove || setDefault ? (
                    <Space key={0} direction="horizontal" size={[5, 5]} align="center" style={{ width: "auto" }}>
                        {setDefault ? (
                            <Tooltip placement="topRight" title={t("ADDRESS_DEFAULT")}>
                                <Checkbox
                                    className="large"
                                    disabled={isDefault || disabled}
                                    checked={isDefault}
                                    onChange={async (event) => {
                                        if (event.target.checked) {
                                            try {
                                                setDisabled(true);
                                                await setDefault(address)
                                            } finally {
                                                setDisabled(false);
                                            }
                                        }
                                    }}
                                />
                            </Tooltip>
                        ) : null}
                        {edit ? (
                            <Tooltip placement="topRight" title={t("EDIT")}>
                                <Button
                                    disabled={disabled}
                                    size={"small"}
                                    className={"card-btn btn"}
                                    onClick={() => setIsModalShown(true)}
                                    type="default"
                                    icon={<FontAwesomeIcon icon={["fas", "pencil-alt"]} />}
                                />
                            </Tooltip>
                        ) : null}
                        {remove ? (
                            <Popconfirm
                                title={t("ARE_YOU_SURE")}
                                onConfirm={() => remove(address)}
                                placement="top"
                                okText={t("YES")}
                                cancelText={t("NO")}
                                disabled={isDefault || disabled}
                            >
                                <Tooltip placement="topRight" title={t("REMOVE")}>
                                    <Button
                                        disabled={isDefault || disabled}
                                        className={"card-btn btn-remove btn"}
                                        type="default"
                                        size={"small"}
                                        icon={<FontAwesomeIcon icon={["fas", "times"]} />}
                                    />
                                </Tooltip>
                            </Popconfirm>
                        ) : null}
                    </Space>
                ) :null}
            >
                <CustomCard data={address} rowKeys={cardRows} />
            </Card>
            {edit && isModalShown ? (
                <AddressListModal
                    item={address}
                    onSubmit={edit}
                    onClose={() => setIsModalShown(false)}
                />
            ) : null}
        </>
    );

};
